import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import Slider from 'react-slick';
import styled from 'styled-components';
import { media } from 'components/responsive';
const messages = defineMessages({
    title: 'Testimonials',
    text1: '“When your doctor’s put you on the course, that can be quite an intimidating thing. But to deliver it with a friendly, upbeat and positive way of getting in the mind frame that, ‘OK, this is gonna be interesting, but it’s gonna be fun’.”',
    text2: '“The course gave me practical tips on how to make small changes to my lifestyle that could have a big impact on my health. I’ve started walking more and eating more fruits and vegetables.”',
    text3: '“Through informative sessions on diabetes prevention, a variety of exercise classes, and daily walking challenges with Sweatcoin, the Decathlon programme has helped me significantly improve my physical and mental health. I was shown how small changes to daily habits make a huge difference to my long-term wellbeing. This programme has shaped my health habits for life. I now have the knowledge and tools I need to make lasting, positive changes.” Geetha (53)',
    text4: '“I’m a male teacher in my mid-30s, and since I started using Sweatcoin, I’ve noticed a significant improvement in my mental and physical wellbeing. When I downloaded the app, it was a wake-up call to see how few steps I was actually taking. Now, Sweatcoin motivates me to stay active and reach my daily target of 10,000 steps.” Kadi (35)',
    text5: '“I wouldn’t understand if you just told me, ‘This is good for you. That’s good for you’. All the background, the science behind it, it was just awesome. You need that to educate people, to help them go forward.”',
    text6: '“You don’t feel isolated, like you’re alone in this. People share and you realise, oh, ‘I’m not on my own’.”',
    text7: '“It’s motivated me to walk more. It’s a good thing for me, one of the best thing that has happened. I can walk more, and now I’m not afraid even if I need to go somewhere and it is 2km, because I can just walk!”',
    text8: '“The programme was really good for me, I’ve changed my food habit a lot, and now I walk almost everywhere. I’m trying to walk more especially now it’s summer, it’s motivating. My daughter will sometimes ask me how much we have walked together when we are out.”',
    text9: '“Every night I look and see if I’ve done enough (steps). My goal is about 9-10k per day. But during the weekend, I’m not walking to school so it’s less. and if it’s not enough then I go to my garden and do some steps there. I’m really enjoying my weight loss and fitting into my clothes!”',
});
const Testimonials = () => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        cssEase: 'linear',
    };
    return (_jsxs(Layout, { children: [_jsx(Title, { children: _jsx(FormattedMessage, Object.assign({}, messages.title)) }), _jsx(TesimonialsSlider, Object.assign({}, settings, { children: ['text1', 'text2', 'text3', 'text4', 'text5', 'text6', 'text7', 'text8', 'text9'].map((i18nkey) => (_jsx(Testimonial, { children: _jsx(Text, { children: _jsx(FormattedMessage, Object.assign({}, messages[i18nkey])) }) }, i18nkey))) }))] }));
};
const Layout = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 50px;
  background: linear-gradient(159deg, rgba(163, 126, 247, 0.5) 2.48%, rgba(255, 255, 255, 0.3) 101.41%);
  margin: 0 16px;
`;
const Title = styled.h2 `
  margin-top: 66px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  text-align: center;
  padding: 0 20px;
  margin-bottom: 40px;
  color: #5e2394;
  font-size: 48px;
  line-height: 1.25;

  ${media.tablet `
    padding: 0;
  `}
`;
const TesimonialsSlider = styled(Slider) `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  margin: 0 0 70px;
  max-width: 100%;

  ${media.desktop `
  max-width: 540px;
  `}
  .slick-dots {
    display: flex !important;
    justify-content: center;
    padding: 0 !important;
    margin: 30px 0 0 !important;

    li {
      list-style: none !important;
      margin: 0 4px;
      line-height: 0;

      button {
        width: 8px;
        height: 8px;
        background: #191841;
        opacity: 0.3;
        border-radius: 6px;
        border: none;
        font-size: 0;
        padding: 0;
        cursor: pointer;
        transition: all 0.3s linear;
      }

      &.slick-active {
        button {
          width: 40px;
          opacity: 1;
        }
      }
    }
  }
`;
const Testimonial = styled.div `
  position: relative;
  padding: 20px 50px 0px;

  ${media.desktop `
  margin: 0 16px 20px;
  padding: 50px 20px 50px 40px;
    `}
`;
const Text = styled.p `
  color: #191841;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.87;
  letter-spacing: -0.096px;
  text-align: center;
  font-family: 'Inter', sans-serif;
`;
export default Testimonials;
